import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';
import { categories } from '@app/src/views/Home/listProducts';
import {
  typeOperationReducer,
  typePropertyReducer,
  districtReducer,
  jobReducer,
  jobTopReducer,
  opportunityReducer,
  freeExtrachargeReducer,
  priceTotalReducer,
  typeVehicleReducer,
  modelVehicleReducer,
  brandVehicleReducer,
  brandVehicleTopReducer,
  yearVehicleReducer
} from '@app/src/views/StepOne/form';
import {
  typePublicationReducer,
  printReducer,
  vignetteReducer,
  extrachargeReducer,
  photoVignetteReducer
} from '@app/src/views/StepTwo/channelPublication';
import { modalError } from '@app/src/common/modalError';
import { calendarReducer } from '@app/src/common/datePicker/state/calendar';
import { summaryReducer } from '@app/src/views/StepThree/publicationConfirmation';
import { dniReducer, rucReducer, priceReducer, paymentReducer } from '@app/src/views/StepPayment/formPayment';
import { flashMessageReducer } from '@app/src/common/flashMessageError';

if (process.env.NODE_SSR) {
  global.window = {};
}

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      categories,
      typeOperation: typeOperationReducer,
      typeProperty: typePropertyReducer,
      typePublication: typePublicationReducer,
      district: districtReducer,
      print: printReducer,
      summary: summaryReducer,
      modalError,
      form: formReducer,
      calendar: calendarReducer,
      dni: dniReducer,
      ruc: rucReducer,
      price: priceReducer,
      payment: paymentReducer,
      job: jobReducer,
      jobTop: jobTopReducer,
      opportunity: opportunityReducer,
      freeExtracharge: freeExtrachargeReducer,
      vignette: vignetteReducer,
      extracharge: extrachargeReducer,
      priceTotal: priceTotalReducer,
      typeVehicle: typeVehicleReducer,
      modelVehicle: modelVehicleReducer,
      brandVehicle: brandVehicleReducer,
      brandVehicleTop: brandVehicleTopReducer,
      yearVehicle: yearVehicleReducer,
      flashMessage: flashMessageReducer,
      photoVignette: photoVignetteReducer
    }),
    (window as any).__PRELOADED_STATE__,
    composeEnhancers(
        applyMiddleware(
            thunk,
        )
    )
  );
  return store;
}
